import { combineReducers } from 'redux';

import * as types from 'modules/contactLists/actionTypes';
import { LOCATION_CHANGE } from 'modules/router/actionTypes';

import { createReducer } from 'utils/ReduxUtils';

const onLocationChange = (_, { payload: { location, action } }) =>
  action === 'PUSH' && Boolean(location?.state?.openCreationModal);

export default combineReducers({
  creation: createReducer(false, {
    [LOCATION_CHANGE]: onLocationChange,
    [types.OPEN_CREATE_CONTACT_LIST]: () => true,
    [types.CLOSE_CREATE_CONTACT_LIST]: () => false,
  }),
});
